// web-common/src/dismiss.js — the ONE outside-click/Escape dismiss (D-AUTH §6, walkthrough
// bug 6: menus stayed open). useDismiss(ref, onClose, { enabled }) is what every popover/
// menu/picker uses: pass the container ref; clicks inside (including the toggle button
// when it's inside the ref) don't dismiss. Sheets keep their scrim-tap and gain Escape.
// The pure core is dismiss-core.js (suite-tested with a fake document, no React).

import { useEffect } from 'react';
import { makeDismissController } from './dismiss-core.js';

export { makeDismissController };

export function useDismiss(ref, onClose, { enabled = true } = {}) {
  useEffect(() => {
    if (!enabled || typeof document === 'undefined') return undefined;
    return makeDismissController(
      document,
      (target) => !!(ref.current && ref.current.contains(target)),
      onClose
    );
  }, [enabled, ref, onClose]);
}
